import { CedroAccountService } from '@services/cedro-account.service';
import { Injectable } from '@angular/core';
import { IEletronicSignature } from '@services/strategy-pattern-login/iEletronic-Signature';
import { Observable , of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IEletronicSignatureWso2Service implements IEletronicSignature {

  constructor(
    private _cedroAccountService: CedroAccountService
  ) { }

  getSignatureParameters() {
    throw new Error('Method not implemented.');
  }

  validateSignature(signature: any) {
    return new Observable<any>(observer => {
      return this._cedroAccountService.validateSignature(signature)
        .subscribe(res => {
          observer.next(res);
        });
    });
  }

  forgotPassword() {
    return new Observable<any>(observer => {
      let forgotSignature = this._cedroAccountService.forgotSignature()
      if(Array.isArray(forgotSignature)){
        return observer.next(forgotSignature);
      }

      return forgotSignature.subscribe(res => {
          observer.next(res);
        });
    });
  }

}
